import _ from "lodash";

const initialState = {
  filteredProjects: {},
  fullProjects: {},
};

const reducer = (state = initialState, action) => {
  // เพิ่ม reducer นี้ขึ้นมาเพื่อแก้ปัญหา entities > projects > entities อัพเดท data เองตอน filter ซึ่งหาจุดแก้ตรงนั้นไม่เจอ
  switch (action.type) {
    case "NEWPROJECTS/FILTEREDPROJECTS/RECEIVED":
      const filteredProjectsObject = {};
      _.map(action.actionFilteredProjects, (project, i) => {
        filteredProjectsObject[_.get(project, "id")] = {
          ...project,
          filteredRooms: _.get(project, "rooms"),
        };
      });
      return {
        ...state,
        filteredProjects: filteredProjectsObject,
      };
    case "NEWPROJECTS/FILTEREDPROJECTS/REPLACE":
      return {
        ...state,
        filteredProjects: action.filteredProjects,
      };
    case "NEWPROJECTS/FULLPROJECTS/RECEIVED":
      const fullProjectsObject = {};
      _.map(action.actionFullProjects, (project, i) => {
        fullProjectsObject[_.get(project, "id")] = {
          ...project,
          fullRooms: _.get(project, "rooms"),
        };
      });
      return {
        ...state,
        fullProjects: fullProjectsObject,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/newProjects/projects.js